import { Hora } from "./hora";

export class Record {

  constructor(
    public fecha: Date,
    public hora: Hora,
    public usuario: string,
    public accion: string
  ) { }
}
